import * as React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";
import { useAreServicesActive } from "../../util/CommonServices";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";
import { monitoringServiceList } from "./MonitoringServiceActive";

const MonitoringTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const { t: tLang } = useTranslation();

    const authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
            };
        }
        return { isIDFUser: "" };
    });

    const isMonitoringServiceActive = useAreServicesActive(monitoringServiceList);

    return (
        <Tab tabId="monitoring-tabs">
            <TabItem title={tLang("alerts.title")} link="/monitoring" tabNo="1" selectedTab={props.selectedTab} />
            {(isMonitoringServiceActive || !authData.isIDFUser) && (
                <TabItem title={tLang("alerts.cases.title")} link="/monitoring/cases" tabNo="2" selectedTab={props.selectedTab} />
            )}
        </Tab>
    );
};

export default MonitoringTab;
